// extracted by mini-css-extract-plugin
module.exports = {"blockGrid":"article-teasers_blockGrid__4bt3L","heading":"article-teasers_heading__xeQ7w","category":"article-teasers_category__H_gcN"};